(() => {
  'use strict';
  const el = document.getElementById('hd-jacket-experiment-config');
  if (!el) return;
  const config = JSON.parse(el.textContent);
  const id = 'hd_jacket_v1';
  const key = 'hd_jacket_v1_assignment';
  const views = { A: 'jacket-control', B: 'reversible-jacket' };
  const url = new URL(location.href);
  const qa = config.preview && ['A', 'B'].includes(url.searchParams.get('jacket_qa'));
  const measureQA = qa && url.searchParams.get('jacket_measure') === '1';
  const clearQA = config.preview && url.searchParams.get('jacket_clear_qa') === '1';
  if (window.Shopify?.designMode || (!qa && !clearQA && (!config.enabled || config.preview))) return;
  if (config.eligible && !['', ...Object.values(views)].includes(config.template)) return;
  let started = false;
  let active = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const root = config.root.replace(/\/?$/, '/');
  const blank = Object.fromEntries(['__hd_jacket_v1', '__hd_jacket_exp_id', '__hd_jacket_client_id', '__hd_jacket_session_id', '__hd_jacket_exposure_id', '__hd_jacket_exposed_at'].map(k => [k, '']));
  const update = attributes => fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes }) });
  function read() {
    try { const a = JSON.parse(localStorage.getItem(key)); return a && views[a.arm] && a.expires > Date.now() ? a : null; }
    catch (_) { return null; }
  }
  function status(message) {
    if (!measureQA && !clearQA) return;
    let p = document.getElementById('hd-jacket-qa-status');
    if (!p) { p = document.createElement('p'); p.id = 'hd-jacket-qa-status'; p.setAttribute('role', 'status'); document.body.appendChild(p); }
    p.textContent = message;
  }
  if (clearQA) {
    fetch(root + 'cart.js', { credentials: 'same-origin' }).then(r => r.json()).then(async cart => {
      if (String(cart.attributes?.__hd_jacket_v1 || '').startsWith('QA_')) {
        const response = await update(blank);
        status(response.ok ? 'QA tracking labels cleared' : 'QA cleanup failed');
      } else status('No QA tracking labels to clear');
    }).catch(() => status('QA cleanup failed'));
    return;
  }
  function get(field) {
    return new Promise(resolve => {
      let done = false;
      const finish = value => { if (!done) { done = true; resolve(value ? String(value) : ''); } };
      setTimeout(() => finish(''), 2000);
      if (typeof window.gtag === 'function') window.gtag('get', config.measurementId, field, finish);
      else finish('');
    });
  }
  async function begin() {
    if (started || ((!qa || measureQA) && !allowed())) return;
    let assignment = qa ? { arm: url.searchParams.get('jacket_qa') } : read();
    if (!assignment && !config.eligible) return;
    if (!assignment) {
      assignment = { arm: crypto.getRandomValues(new Uint32Array(1))[0] < 2147483648 ? 'A' : 'B', expires: Date.now() + 90 * 86400000 };
      try { localStorage.setItem(key, JSON.stringify(assignment)); if (read()?.arm !== assignment.arm) return; } catch (_) { return; }
    }
    started = true;
    const arm = assignment.arm;
    if (config.eligible && config.template !== views[arm]) { url.searchParams.set('view', views[arm]); location.replace(url.href); return; }
    if (qa && !measureQA) return;
    // Only an actually rendered eligible page can establish an exposure.
    if (!config.eligible && !assignment.attribution) return;
    let a = assignment.attribution;
    if (config.eligible) {
      if (typeof window.gtag === 'function' && /^G-[A-Z0-9]+$/.test(config.measurementId)) window.gtag('config', config.measurementId, { send_page_view: false });
      const [clientId, sessionId] = await Promise.all([get('client_id'), get('session_id')]);
      if (!allowed()) return;
      if (!clientId || !window.Shopify?.analytics?.publish) { status('QA tracking unavailable: analytics identity or event bridge missing'); return; }
      a = { experiment_id: measureQA ? 'hd_jacket_qa_20261022' : id, experiment_variant: arm,
        client_id: clientId, session_id: sessionId, exposure_id: crypto.randomUUID(), exposed_at: Date.now() };
    }
    if (!allowed()) return;
    const attrs = { __hd_jacket_v1: measureQA ? 'QA_' + arm : arm, __hd_jacket_exp_id: a.experiment_id,
      __hd_jacket_client_id: a.client_id, __hd_jacket_session_id: a.session_id,
      __hd_jacket_exposure_id: a.exposure_id, __hd_jacket_exposed_at: String(a.exposed_at) };
    try {
      const response = await update(attrs);
      if (!response.ok) throw Error('cart');
      if (!allowed()) { await update(blank); return; }
      active = true;
      if (!qa) { assignment.attribution = a; localStorage.setItem(key, JSON.stringify(assignment)); }
      if (config.eligible) {
        await window.Shopify.analytics.publish('hd_jacket_exposure', a);
        status('QA checkout attribution saved: QA_' + arm + ' | tracking v2');
      }
    } catch (_) { status('QA attribution failed; exposure not recorded'); }
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) {
      try { localStorage.removeItem(key); } catch (_) {}
      if (active) update(blank).catch(() => {});
      active = false;
      started = false;
      return;
    }
    begin();
  });
  if ((qa && !measureQA) || window.Shopify?.customerPrivacy) begin();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) begin(); });
})();